import { Wrapper } from '@cinch-nx/shared-ui'
import styles from './feature-modern-slavery-hub.module.css'
import { ModernSlaveryHubProps } from './get-static-props'

export const ModernSlaveryHub = ({ links }: ModernSlaveryHubProps) => (
  <div className={styles.linkContainer}>
    <Wrapper isSlim>
      <ul>
        {links
          .sort((a, b) => Number(b.name) - Number(a.name))
          .map((link) => (
            <li className={styles.link} key={link.name}>
              <a href={`/${link.slug.replace('statements/', '')}`}>
                Modern slavery statement {link.name}
              </a>
            </li>
          ))}
      </ul>
    </Wrapper>
  </div>
)
